import PropTypes from "prop-types";
import moment from "moment";
import { numberWithSpaces } from "../../../../utilities/formaters";

const AdHocInfo = ({ item }) => (
  <div style={{ marginBottom: "7px" }}>
    <strong>
      {moment(item.RequestTimestamp).format("YYYY-MM-DD - HH:mm:ss")}
    </strong>
    <br />
    <span>Status: {item.OrderStatus}</span>
    <br />
    <span>Repayment Date: {moment(item.Date).format("YYYY-MM-DD")}</span>
    <br />
    <span>Amount: {numberWithSpaces(item.Amount.Amount)} kr</span>
    <br />
  </div>
);

AdHocInfo.propTypes = {
  item: PropTypes.object,
};

export default AdHocInfo;
